import {useImperativeHandle, useState} from 'react';
import Swal from 'sweetalert2'
// import {useNivelesEstructure} from "hooks/useNivelesEstructure";

function Search({getNivelesEstructure, setIsSearched, formRef}){
//  const {allNivelesEstructure} = useNivelesEstructure();

 const [search, setSearch] = useState('')
 const [option, setOption] = useState('')

 useImperativeHandle(formRef, () => ({
        reset: () => {
            setOption('');
            setSearch('');
        }
    })
 );

 const showError = ({message}) => {
    Swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: message,
    })
 }
 const handleChangeOption = (e) => {
    if(e.target.value !== "nivel" || e.target.value !== "flujo"){
        setSearch("");
    }
   setOption(e.target.value)

 }
 const handleChangeSearch = (e) => {
   setSearch(e.target.value)
 }
 const handleSubmit = (e) => {
    e.preventDefault();
    switch(option){
        case "":
            showError({message: 'Seleccione una opción de búsqueda'})
            break;            
        case "nivel":
            if(!search) return showError({message: "Escriba un Nivel"});
            getNivelesEstructure({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        case "flujo":
            if(!search) return showError({message: "Escriba un Flujo"});
            getNivelesEstructure({page: 1, [option]: search})
            setIsSearched({
                option,
                search,
                state: true
            })
            break
        default:
            getNivelesEstructure({})
            break

    }
 }
 return (
 <div>    
  <div className="row mb-2">
   <h6>Busqueda de Niveles</h6>
  </div>
  <div className="table-responsive rounded-3 d-flex justify-content-center" style={{border:'1px solid black', paddingTop:'15px'}}>
        <form className="row g-3">
            <div className="col-auto">
                <select onChange={handleChangeOption} className="form-select" aria-label="Default select example" value={option}>
                    <option value="">Seleccione</option>
                    <option value="nivel">Nivel</option>
                    <option value="flujo">Flujo</option>

                </select>
            </div>
            <div className="col-auto">
                {
                    option === "nivel"
                    ?
                    <select name="search" id="search" className="form-control" onChange={handleChangeSearch}  value={search}>
                        <option value="" disabled>--Seleccione--</option>
                        <option value="MZ_TIPO_NIVEL1">MZ_TIPO_NIVEL1</option>
                        <option value="MZ_TIPO_NIVEL2">MZ_TIPO_NIVEL2</option>
                        <option value="MZ_TIPO_NIVEL3">MZ_TIPO_NIVEL3</option>
                        <option value="MZ_TIPO_NIVEL4">MZ_TIPO_NIVEL4</option>
                        <option value="MZ_TIPO_NIVEL5">MZ_TIPO_NIVEL5</option>
                        <option value="MZ_TIPO_NIVEL6">MZ_TIPO_NIVEL6</option>

                        <option value="CP_TIPO_NIVEL1">CP_TIPO_NIVEL1</option>
                        <option value="CP_TIPO_NIVEL2">CP_TIPO_NIVEL2</option>
                        <option value="CP_TIPO_NIVEL3">CP_TIPO_NIVEL3</option>
                        <option value="CP_TIPO_NIVEL4">CP_TIPO_NIVEL4</option>
                        <option value="CP_TIPO_NIVEL5">CP_TIPO_NIVEL5</option>
                        <option value="CP_TIPO_NIVEL6">CP_TIPO_NIVEL6</option>

                        <option value="IT_TIPO_PLACA">IT_TIPO_PLACA</option>                        
                    </select>
                    :
                    option === "flujo"
                    ?
                    <select name="search" id="search" className="form-control" onChange={handleChangeSearch} value={search}>
                        <option value="" disabled>--Seleccione--</option>
                        <option value={"barrio-manzana"}>Barrio Manzana</option>
                        <option value={"calle-carrera"}>Calle Carrera</option>
                    </select>
                    :
                    <input type="text" className="form-control" id="search" name="search" onChange={handleChangeSearch} value={search}/>
                }
            </div>
            <div className="col-auto">
                <button type="submit" className="btn btn-primary mb-3" onClick={handleSubmit}>Buscar</button>
            </div>
        </form> 
    </div>
 </div>
 )
}
export default Search
